import { render } from "./HouseItem.vue?vue&type=template&id=69016a5a&scoped=true&ts=true"
import script from "./HouseItem.vue?vue&type=script&lang=ts"
export * from "./HouseItem.vue?vue&type=script&lang=ts"

import "./HouseItem.vue?vue&type=style&index=0&id=69016a5a&scoped=true&lang=css"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69016a5a"]])

export default __exports__